<template>
  <v-container
    fluid
    style="background: #f5f5f5"
    class="login-container ma-0 pa-0"
  >
    <v-row class="login-container">
      <v-col cols="8">
        <div class="login">
          <div class="login-form">
            <div>
              <div class="p-title left-text">{{ title }}</div>

              <br />

              <div v-if="monthlyUpdate" class="left-text">
                Su contraseña ha expirado, favor de actualizar sus credenciales.
              </div>

              <br />

              <v-form ref="form" v-model="isFormValid">
                <v-text-field
                  label="Contraseña actual"
                  filled
                  v-model="model.password"
                  :rules="[rules.required]"
                  type="password"
                >
                </v-text-field>

                <v-text-field
                  label="Nueva contraseña"
                  filled
                  maxlength="16"
                  counter
                  v-model="model.newPassword"
                  :rules="[rules.required, rules.password]"
                  type="password"
                >
                </v-text-field>

                <v-text-field
                  label="Confirmar contraseña"
                  filled
                  maxlength="16"
                  counter
                  v-model="model.confirmPassword"
                  :rules="[
                    rules.required,
                    rules.password,
                    rules.confirmPassword,
                  ]"
                  type="password"
                >
                </v-text-field>
              </v-form>

              <div class="flex-grow-1"></div>

              <v-btn
                block
                v-show="inLogin"
                :disabled="!isFormValid || isDisabled"
                color="secondary"
                @click="save"
              >
                Guardar
              </v-btn>

              <br />

              <v-alert type="error" dense outlined v-model="showAlert">
                {{ passwordAlerts }}
              </v-alert>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { events } from "./../../main";

export default {
  components: {},

  data() {
    return {
      id: localStorage.getItem("userId"),
      title: "Cambiar contraseña",
      inLogin: true,
      monthlyUpdate: this.$route.params.monthUpdate,
      isFormValid: false,
      showAlert: false,
      model: {
        password: "",
        newPassword: "",
        confirmPassword: "",
      },
      rules: {
        required: (v) => !!v || "La contraseña es requerida",
        counter: (v) => v.length <= 16 || "Máximo 16 caracteres",
        password: (v) => {
          return (
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/.test(v) ||
            "Contraseña invalida"
          );
        },
        confirmPassword: (v) => {
          return (
            this.model.newPassword === this.model.confirmPassword ||
            "Contraseñas no coinciden"
          );
        },
      },
    };
  },

  props: {},

  methods: {
    save() {
      if (this.$refs.form.validate()) {
        this.sending = true;
        this.$http.put("user/changepassword/" + this.id, this.model).then(
          (response) => {
            this.snackbar("Registro actualizado con éxito");
            this.$router.push("/");
          },
          (error) => {
            this.sending = false;
            var message = "Error al actualizar registro";
            message += error.status === 400 ? ", Contraseña Incorrecta" : "";
            this.form = {};
            this.snackbar(message);
            console.error(error);
          }
        );
      }
    },

    snackbar(message) {
      events.$emit("snackbar", message);
    },
  },

  computed: {
    isDisabled: function () {
      if (this.model.newPassword == this.model.confirmPassword) {
        return false;
      } else {
        return true;
      }
    },
  },

  directives: {
    focus: {
      inserted: function (el) {
        el.focus();
      },
    },
  },

  watch: {
    "model.newPassword": function () {
      this.showAlert = true;
      if (this.model.newPassword.length < 8) {
        return "La contraseña debe tener 8 o más caracteres.";
      }
      if (!this.model.newPassword.match(/[a-z]/g)) {
        return "La contraseña debe incluir al menos una minúscula.";
      }
      if (!this.model.newPassword.match(/[A-Z]/g)) {
        return "La contraseña debe incluir al menos una mayúscula.";
      }
      if (!this.model.newPassword.match(/[0-9]/g)) {
        return "La contraseña debe incluir al menos un número.";
      }
      this.showAlert = false;
    },
  },

  created() {},

  mounted() {},
};
</script>

<style scoped>
.login-container {
  height: 100%;
  margin-top: 5%;
  margin-bottom: 5% !important;
}

.login {
  height: 100%;
  padding-left: 5%;
  padding-right: 50%;
}

.login-form {
  min-width: 30%;
}

.forgot-password {
  text-align: left;
  height: 100%;
  background: #f5f5f5;
  color: #4b5156;
  padding: 10%;
}

.logo {
  padding: 2%;
  text-align: left;
}

.p-title {
  font-size: 25px;
  font-weight: 700;
  color: #063c78;
}

.left-text {
  text-align: left;
}

.v-banner {
  background-image: url("https://images.pexels.com/photos/1054397/pexels-photo-1054397.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260");
  background-repeat: no-repeat;
  height: 100%;
  background-size: cover;
}

.logo img {
  height: 80px;
  width: auto;
}

.title {
  color: white;
  font-size: 45px;
  margin-top: 50px;
  margin-bottom: 30px;
}

.subtitle {
  font-size: 30px;
  margin-bottom: 60px;
}

.recover-password {
  text-align: center;
}

.forgot-password .forgot-password-text .btn-forgot-password button {
  background-color: #4b5156;
  color: white;
  margin-left: 0;
  margin-top: 30px;
}

.btn-login {
  text-align: left;
  padding: 0;
}

.btn-login button {
  margin-left: 0;
}
</style>
